import React from 'react';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem, Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Table,
} from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";

const CertificateInformation12 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const coursetrack = location.state ? location.state.courseTrack : "";
    const coursename = location.state ? location.state.courseName : "";
    const [open, setOpen] = React.useState(['7']); // Initialize open state with an empty array

    const toggle = (id) => {
        setOpen(prevOpen => {
            if (prevOpen.includes(id)) {
                // If the section is already open, remove it from the open state
                return prevOpen.filter(item => item !== id);
            } else {
                // If the section is not open, add it to the open state
                return [...prevOpen, id];
            }
        });
    };
    const handleEnrollClick = () => {

        navigate("/application-form", {
            state: {
                courseTrack: coursetrack,
                courseName: coursename,

            },
        });
    };

    return (

        <>



        <div className="container mt-1 p-3 mb-1" >


            <Row>
                <Col>
                    <h2 className=" text-center" style={{ color: '#123fae' }}
                    >
                       Certificate Course in Adobe (DTP)

                        {/* <a href='a'
                            style={{ float: "right", fontSize: 15, color: "#e74c3c" }}
                            className="d-block mx-auto"
                            onClick={(event) => {
                                event.preventDefault(); // Prevents the default behavior (page reload)
                                handleEnrollClick(); // Calls your handleEnrollClick function
                            }}
                        >
                            Register Now
                        </a> */}

                    </h2>




                </Col>
            </Row>

            {/* <h4>Course Details:</h4> */}
            <Row>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card >
                        <CardHeader>
                            Course Details:
                        </CardHeader>




                        <ListGroup flush >

                            <ListGroupItem>
                                Language: English
                            </ListGroupItem>
                            <ListGroupItem>
                                Duration: 120 hours (3 months)
                            </ListGroupItem>
                            <ListGroupItem>
                                Learning Mode: Online
                            </ListGroupItem>
                            <ListGroupItem>
                                Certificate of Completion
                            </ListGroupItem>


                        </ListGroup>
                    </Card  ></Col>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card style={{ minHeight: "100%" }}>
                        <CardHeader >
                            Eligibility:
                        </CardHeader>




                        <ListGroup flush className="px-2">

                            <ListGroupItem>
                                <li> Learner should preferably be a 12th std. Pass student.</li>

                            </ListGroupItem>

                        </ListGroup>
                    </Card></Col>
            </Row>
            <br />
            <hr />
            <div >
                <h5 style={{ position: "relative" }}>
                    <span >
                        &#x1F449;
                    </span>
                    Why Certificate Course in Adobe (DTP)
                </h5>
                <p>
                    The DTP (Adobe) 120 hours course is designed to equip learners with the essential skills needed for effective desktop publishing using industry-standard tools like Adobe and CorelDRAW. This comprehensive 120-hour program delves into the intricacies of design, layout, and graphics manipulation, providing a solid foundation for aspiring graphic designers and desktop publishers.</p>


            </div>
            <hr />




            <h5 style={{ position: "relative" }}>

                What you'll learn ?
            </h5>

            <p>This 120-hour course is structured to provide a balance between theoretical knowledge and practical application, making it suitable for beginners and those looking to enhance their existing skills in desktop publishing. Learners of the DTP program emerge with a comprehensive skill set, ready to make a meaningful impact in the dynamic field of graphic design and desktop publishing.</p>
            <hr />

            <h5 style={{ position: "relative" }}>

                Course Highlights:
            </h5>
            <ul>
                <li> Introduction to Desktop Publishing: Learners will gain a fundamental understanding of the principles and practices of desktop publishing, exploring its role in creating visually appealing documents.</li>
                <li>Adobe Creative Suite: The course extensively covers Adobe InDesign, Photoshop, and Illustrator, enabling learners to master these tools for creating professional-grade layouts, images, and vector graphics.</li>
                <li>Typography and Layout Design: The program emphasizes the importance of effective typography and layout design, guiding learners in creating visually appealing and readable documents.</li>
                <li>Print Production Techniques: Learners will learn about the intricacies of print production, including colour management, resolution, and preparing files for print.</li>
                <li>Project Work: Practical application is a key component of the course, with hands- on projects allowing learners to apply their skills in real-world scenarios.</li>
                <li> Industry-Relevant Skills: The curriculum is tailored to meet industry demands, ensuring that learners are well-prepared for careers in graphic design, advertising, and print media.</li>

            </ul>
            <hr />




            <div >
                <h5 style={{ left: "0" }}>Certification</h5>
                <ul><li> Adobe (DTP) course is jointly certified by CDOE GJUST and HKCL.</li>
                </ul>

            </div>
            <hr />
            
            <div >
                <h5 style={{ left: "0" }}>Academic Approach</h5>
                <p>
                    The academic approach of the courses focuses on the “work-centric” education i.e. begin with work (and not from a book!), derive knowledge from work and apply that knowledge to make the work more wholesome, useful and delightful. The ultimate objective is to empower the Learner to engage in socially useful and productive work. It aims at leading the learner to his/her rewarding career as an employee or entrepreneur as well as development of the community to which s/he belongs.
                    Learning methodology:
                </p>


                <ul>
                    <li>Step -1: Learners are given an overview of the course and its connection to life and work.</li>
                    <li>Step -2: Learners are exposed to the specific tool(s) used in the course through the various real-life applications of the tool(s).</li>
                    <li>Step -3: Learners are acquainted with the careers and the hierarchy of roles they can perform at workplaces after attaining increasing levels of mastery over the tool(s).</li>
                    <li>Step -4: Learners are acquainted with the architecture of the tool or tool map so as to appreciate various parts of the tool, their functions, utility and inter-relations.</li>
                    <li>Step -5: Learners are exposed to simple application development methodology by using the tool at the beginner’s level.</li>
                    <li>Step -6: Learners perform the differential skills related to the use of the tool to improve the given ready-made industry-standard outputs.</li>
                    <li>Step -7: Learners are engaged in appreciation of real-life case studies developed by the experts.</li>
                    <li>Step -8: Learners are encouraged to proceed from appreciation to imitation of the experts.</li>
                    <li>Step -9: After the imitation experience, they are required to improve the expert’s outputs so that they proceed from mere imitation to emulation.</li>
                    <li>Step -10: Emulation is taken a level further from working with differential skills towards the visualization and creation of a complete output according to the requirements provided. (Long Assignments)</li>
                    <li>Step -11: Understanding the requirements, communicating one’s own thoughts and presenting are important skills required in facing an interview for securing a work order/job. For instilling these skills, learners are presented with various subject-specific technical as well as HR-oriented questions and encouraged to answer them.</li>
                    <li>Step -12: Finally, they develop the integral skills involving optimal methods and best practices to produce useful outputs right from scratch, publish them in their ePortfolio and thereby proceed from emulation to self-expression, from self-expression to self-confidence and from self-confidence to self-reliance and self-esteem!</li>
                </ul>
            </div>
            <hr />
            <div >
                <h5 style={{ left: "0" }}>Admission Guidelines</h5>
                <p>
                   
                    <li>
            <b>Online Registration: </b> Learner needs to visit <a href="https://www.gjuskillcourses.hkcl.in">www.gjuskillcourses.hkcl.in</a> and make an online payment for admission confirmation. Kindly refer online admission process guidelines for more details.
          </li>
                </p>
                <hr />
            </div>

            <h5>Syllabus</h5>

            <div className='p-4' >



                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="7">Introduction to DTP</AccordionHeader>
                        <AccordionBody accordionId="7">
                            <ul>
                                <li> Purpose of Learning DTP</li>
                                <li> Getting introduced to the DTP Course</li>
                                <li> Understanding what Desktop Publishing is</li>
                                <li> Knowing where DTP is used.</li>
                                <li> Understanding who uses DTP.</li>
                                <li> DTP in marketing: importance and usage</li>
                                <li> Learning DTP formats and outputs</li>
                                <li> Taking real-life examples of DTP</li>
                                <li> Understanding print and online in DTP</li>
                                <li> Learning about tools for DTP</li>
                                <li> Working with images</li>
                                <li> How to choose images</li>
                                <li> Understanding and using the image Resources</li>
                                <li> What are copyrights?</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="8">Adobe Photoshop CC</AccordionHeader>
                        <AccordionBody accordionId="8">
                            <ul>
                                <li>Learning about Adobe Photoshop CC</li>
                                <li>Learning Adobe Photoshop CC features and tools</li>
                                <li>Editing and creating photos quickly</li>
                                <li>Other important enhancements</li>
                                <li>Creative Cloud Docs</li>
                                <li>Getting started with Photoshop.</li>
                                <li>Introduction to the basics of Photoshop</li>
                                <li>Introduction to Photoshop</li>
                                <li> Pixels and Resolution</li>
                                <li> Introduction to basic tools</li>
                                <li> Exploring Adobe Photoshop workspace and customization</li>
                                <li> Photoshop Interface</li>
                                <li>Organizing</li>
                                <li> Saving</li>
                                <li> Image, Color Modification Understanding</li>
                                <li>Image Modifications</li>
                                <li>Color Modifications</li>
                                <li>Mastering Adobe Photoshop tools</li>
                                <li>Using the basic tools</li>
                                <li>Using the selection tools</li>
                                <li> Using the drawing and coloring tools</li>
                                <li>Learning to use the tools of Adobe Photoshop</li>
                                <li> Exploring drawing and coloring tools</li>
                                <li> Case Study - Black & White to Color</li>
                                <li> Coloring black and white design</li>
                                <li> Finishing up the coloration work</li>
                                <li> Learning to use the tools of Adobe Photoshop</li>
                                <li> Using the advanced tools</li>
                                <li> Using the text tools</li>
                                <li> Let's learn more about Photoshop.</li>
                                <li> Learning more about Adobe Photoshop</li>
                                <li> Advancing in Adobe Photoshop skills</li>
                                <li> Using the Brush and Paint</li>
                                <li> Using the Brush presets</li>
                                <li> Using the Colors, and Shapes</li>
                                <li> Working with Selections</li>
                                <li> Making selections with different tools</li>
                                <li> Modifying an Existing Selection</li>
                                <li> Saving and Loading Selections</li>
                                <li> Scaling</li>
                                <li> Using the Transform tool</li>
                                <li> Using the Content Aware Scaling Tool</li>
                                <li> Knowing the Layers</li>
                                <li> Working with layers</li>
                                <li> Case Study - Photo Collage</li>
                                <li> Learning to create a Photo Collage</li>
                                <li> Discovering Filter Gallery filters</li>
                                <li> Using filters and effects in Photoshop</li>
                                <li> Case Study - Greeting Card</li>
                                <li> Creating Greeting Card in Photoshop</li>
                                <li> Modifying, completing Greeting Card design</li>
                                <li> Identifying, applying color adjustments</li>
                                <li> Discovering color levels and adjustment levels</li>
                                <li> Mastering the color adjustments</li>
                                <li> Identifying and applying the new color adjustments</li>
                                <li> Additional color adjustments: Understanding</li>
                                <li> Case Study - Photo Manipulation</li>
                                <li> Manipulating a photo in Adobe Photoshop</li>
                                <li> Completing photo manipulation in Adobe Photoshop</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="9">Starting a Client based Project</AccordionHeader>
                        <AccordionBody accordionId="9">
                            <ul>
                                <li>Meeting the client</li>
                                <li>Client Brief</li>
                                <li>Content and Graphics</li>
                                <li> Marketing Plan</li>
                                <li>Look n feel.</li>
                                <li>How to start designing an output</li>
                                <li>What are primary sketches?</li>
                                <li>The process of designing an output</li>
                                <li>What is a Moodboard?</li>
                                <li>Outcome</li>
                                <li>Printing and scanning basics: Understanding.</li>
                                <li>Listing various types of printers</li>
                                <li>Printers based on technology: Learning.</li>
                                <li>Printers based on characteristics: Learning.</li>
                                <li>Learning about the different printer qualities</li>
                                <li>Case Study: Brochure</li>
                                <li>Learning about shapes and designing a Brochure</li>
                                <li> Designing Shapes, Completing Brochure design</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="10">Printing Concepts</AccordionHeader>
                        <AccordionBody accordionId="10">
                            <ul>
                                <li>Learning about the printing concepts</li>
                                <li> Learning about the printing terms</li>
                                <li>Case Study: Product Box Package</li>
                                <li>Creating a nice Product Box Package design</li>
                                <li>Formatting, exporting Product Box design.</li>
                                <li> Learning about the printing concepts</li>
                                <li> Understanding DPI & Resolution</li>
                                <li> Defining the printing fonts</li>
                                <li> Identifying the ideal file formats</li>
                                <li> Learning about the printing technologies</li>
                                <li> Identifying various printing methods</li>
                                <li> Learning about the printing technologies</li>
                                <li> Studying Digital Printing vs. Offset Printing</li>
                                <li> Defining the types of printer papers</li>
                                <li> Types of printer papers: Understanding</li>
                                <li> Suitable papers for printer types: Understanding</li>
                                <li> Attributes of printer papers: Learning</li>
                                <li>Post Press – Print Project Finishing</li>
                                <li> Completing a Print Project</li>
                                <li> Case Study: Book Cover</li>
                                <li> Creating, designing Book Cover in new document</li>
                                <li> Finishing Book Cover design</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="11">Adobe Illustration</AccordionHeader>
                        <AccordionBody accordionId="11">
                            <ul>
                                <li>Mastering the next level in Adobe Illustrator</li>
                                <li>Using the specialized tools</li>
                                <li>Using the Reshaping tools</li>
                                <li>Using the specialized tools</li>
                                <li> Using the Graph Tools</li>
                                <li>Using the slicing and cutting tools</li>
                                <li>Using the Symbol tool</li>
                                <li>Getting Creative with Types</li>
                                <li> Using and Modifying a Type</li>
                                <li>Using Character and Paragraph Palettes</li>
                                <li> Understanding what Area Type is</li>
                                <li> Understanding what Path Type is</li>
                                <li> Using the Symbols</li>
                                <li> Learning to use the Symbol option.</li>
                                <li> Exploring the Symbol Library</li>
                                <li> Designing Graphics</li>
                                <li> Using Graphics</li>
                                <li> Designing Graphics</li>
                                <li> Applying graphic styles</li>
                                <li>Using and applying effects and filters</li>
                                <li>Applying Effects</li>
                                <li>Using and applying effects and filters</li>
                                <li>Using Effects for enhancement</li>
                                <li>Playing With Palettes</li>
                                <li>Arranging the Workspace</li>
                                <li>Case Study- Coupon</li>
                                <li> Creating a coupon design in Adobe Illustrator</li>
                                <li> Learning about various color palettes</li>
                                <li> Printing and its concepts</li>
                                <li> Understanding the basics of printing</li>
                                <li> Understanding the Artboard printing techniques</li>
                                <li> Learning about colors in printing</li>
                                <li> Exporting the design output</li>
                                <li> Exporting documents in different file formats</li>
                                <li> Exporting documents for Adobe Applications</li>
                                <li> Elements of print-ready output for publication</li>
                                <li> Understand Illustrator's role in print media.</li>
                                <li> Working smartly in Adobe Illustrator - I</li>
                                <li> Using the shortcut keys for smart work</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="13">Adobe inDesign</AccordionHeader>
                        <AccordionBody accordionId="13">
                            <ul>
                                <li>Getting started with Adobe InDesign</li>
                                <li>Getting introduced to Adobe InDesign</li>
                                <li>Understanding Quick Preview</li>
                                <li>Getting Started with InDesign</li>
                                <li>Exploring the Workspace</li>
                                <li>Getting started with Adobe InDesign</li>
                                <li>Using Toolbox</li>
                                <li>Working with Documents</li>
                                <li>Working with Panels</li>
                                <li>Getting Help while you work</li>
                                <li>Creating and Viewing a Document</li>
                                <li>Creating a New Document</li>
                                <li>Creating a New Document from a Template</li>
                                <li>Creating New Document Using Presets</li>
                                <li>Setting up a Document</li>
                                <li>Using the Zoom and Hand tools</li>
                                <li>Working with Rulers</li>
                                <li>Working with Guides</li>
                                <li>Creating and Viewing a Document</li>
                                <li>Using Smart Guides</li>
                                <li>Using Grids</li>
                                <li>Working with the Info Panel</li>
                                <li> Creating and Displaying Workspaces</li>
                                <li>Changing the Display View</li>
                                <li>Using Undo and Redo</li>
                                <li>Managing the pages and books in an InDesign document</li>
                                <li>Using the Pages Panel</li>
                                <li>Inserting pages</li>
                                <li>Navigating pages</li>
                                <li>Deleting or Moving Pages</li>
                                <li>Working with Page Spreads</li>
                                <li>Managing the pages and books in an InDesign document</li>
                                <li>Creating Master pages</li>
                                <li>Working with Master Pages</li>
                                <li>Working with Page Number and Sections</li>
                                <li>Working with Chapter Numbers</li>
                                <li>Creating and Using Text Variables</li>
                                <li>Creating a Book</li>
                                <li>Managing Books</li>
                                <li>Creating a Table of Contents</li>
                                <li>Adjusting Layouts</li>
                                <li>Inserting and arranging text in InDesign</li>
                                <li>Using the Type tool</li>
                                <li>Adding Text to Frame</li>
                                <li>Inserting and arranging text in InDesign</li>
                                <li>Threading text</li>
                                <li>Editing text</li>
                                <li>Using the Find/Change feature</li>
                                <li>Working with Glyphs and Special Characters</li>
                                <li>Using Spell-check and Language Dictionaries</li>
                                <li>Formatting and enhancing the text</li>
                                <li>Formatting text</li>
                                <li>Changing Fonts and Font Size</li>
                                <li>Text Leading</li>
                                <li>Kerning and tracking</li>
                                <li>Formatting paragraphs</li>
                                <li>Aligning text</li>
                                <li>Bullets and Numbering</li>
                                <li>Text Composition</li>
                                <li>Tabs and indents</li>
                                <li>Mastering the next level in Adobe InDesign skills</li>
                                <li>Placing and working with Graphics</li>
                                <li>Placing Graphics</li>
                                <li>Placing Multiple Graphics</li>
                                <li>Using the Links Panel</li>
                                <li>Embedding links</li>
                                <li>Editing Original Graphics</li>
                                <li>Case Study- Flyer</li>
                                <li>Setting up Flyer in Adobe InDesign</li>
                                <li>Modifying and finishing the Flyer design</li>
                                <li>Placing and working with graphics</li>
                                <li>Setting Frame-fitting Options</li>
                                <li>Setting compound paths</li>
                                <li>Colorizing images</li>
                                <li>Controlling Graphics Display Performance</li>
                                <li>Displaying XMP Graphics Information</li>
                                <li>Inserting and working with objects</li>
                                <li>Creating a New Object</li>
                                <li>Creating Lines</li>
                                <li>Selecting objects</li>
                                <li>Using Basic Strokes and Fills</li>
                                <li>Using advanced strokes</li>
                                <li>Inserting and working with objects</li>
                                <li>Using Transparency</li>
                                <li>Adding Drop Shadows</li>
                                <li>Applying Feathering</li>
                                <li> Case Study- Menu Card</li>
                                <li> Designing Menu Card using Type tool</li>
                                <li> Enhancing, completing Menu Card design creatively</li>
                                <li> Using Other Effects to Format Objects</li>
                                <li>Using the Eyedropper tool</li>
                                <li> Case Study- Brochure</li>
                                <li> Create Brochure in Adobe InDesign, set up document.</li>
                                <li> Enhancing and completing the Brochure design</li>
                                <li> Arranging, managing, and transforming objects</li>
                                <li> Stacking objects</li>
                                <li> Creating a New Layer</li>
                                <li> Using Layers</li>
                                <li> Nesting Objects</li>
                                <li> Editing Frame and Path Shapes</li>
                                <li> Understanding Corner Options</li>
                                <li> Arranging, managing, and transforming objects</li>
                                <li> Grouping and Locking Objects</li>
                                <li> Aligning and Distributing</li>
                                <li> Using Anchored Objects</li>
                                <li>  Transforming Objects</li>
                                <li> Duplicating and Flipping Objects</li>
                                <li> Working with Points and Paths</li>
                                <li> Drawing with the Pen Tool</li>
                                <li>Selecting and Moving Points and Segments</li>
                                <li> Converting Points</li>
                                <li> Adding and Deleting Anchor Points</li>
                                <li> Splitting Paths</li>
                                <li> Using the Smooth tool</li>
                                <li> Using the Pencil Tool</li>
                                <li> Working with Points and Paths</li>
                                <li> Working with Pathfinder</li>
                                <li> Joining and Closing Anchor Points</li>
                                <li> Reshape Paths</li>
                                <li> Creating a Compound Path</li>
                                <li> Case Study- Book Cover</li>
                                <li> Creating a Book Cover in Adobe InDesign</li>
                                <li> Finalizing book cover design in InDesign</li>
                                <li> Applying and Managing Color</li>
                                <li> Working With Color Modes</li>
                                <li> Applying Color</li>
                                <li> Using the Eyedropper Tool</li>
                                <li> Working with the Color Panel</li>
                                <li> Working with Swatches</li>
                                <li> Tints</li>
                                <li> Applying and adjusting the colors</li>
                                <li> Applying Gradients</li>
                                <li> Mixing Inks</li>
                                <li> Using Colors from Imported Graphics</li>
                                <li> Inserting and working with Tables</li>
                                <li> Creating a Table</li>
                                <li> Selecting Rows and Columns</li>
                                <li> Inserting and working with Tables</li>
                                <li> Adding and Deleting Rows and Columns</li>
                                <li> Formatting a Table</li>
                                <li> Formatting Cells</li>
                                <li> Adding Headers and Footers</li>
                                <li> Applying Table Styles</li>
                                <li> Placing Graphics in Cells</li>
                                <li> Adding Microsoft Word and Excel Tables</li>
                                <li> Applying and working with Styles</li>
                                <li> Using the Styles Panels</li>
                                <li> Applying Character Styles</li>
                                <li> Applying Paragraph Styles</li>
                                <li> Creating GREP Style</li>
                                <li> Creating a Style Group</li>
                                <li> Using Nested Styles</li>
                                <li> Adobe InDesign for bulk output creation</li>
                                <li> Get job-ready with best software training.</li>
                                <li> Using Object Styles</li>
                                <li> Creating Table and Cell styles</li>
                                <li> Using Quick Apply</li>
                                <li> Case Study- User Manual</li>
                                <li> Designing a User Manual in Adobe InDesign</li>
                                <li> Entering content and Finishing up User Manual</li>
                                <li> Mastering the last level in InDesign</li>
                                <li> Finalizing Documents</li>
                                <li> Using Custom Dictionaries</li>
                                <li> Finding and Changing Fonts</li>
                                <li> Using Find and Change</li>
                                <li> Searching for Text</li>
                                <li>Searching using GREP</li>
                                <li> Finalizing the InDesign documents</li>
                                <li>Searching for Glyphs</li>
                                <li>Searching for Objects</li>
                                <li>Working with Hyphenation</li>
                                <li>Keeping Lines together</li>
                                <li>Changing Justification Options</li>
                                <li>Changing Case</li>
                                <li>Using the Story Editor</li>
                                <li>Finalizing the InDesign documents</li>
                                <li>Adding Footnotes</li>
                                <li>Working with Notes</li>
                                <li>Exporting a document in Adobe InDesign</li>
                                <li>Exporting a Document</li>
                                <li>Understanding Export File Formats</li>
                                <li>Exporting as PDF File</li>
                                <li>Case Study- News Paper Article</li>
                                <li>Designing newspaper article in Adobe InDesign</li>
                                <li>Exporting document in Adobe InDesign</li>
                                <li>Exporting as an EPS</li>
                                <li>Exporting Cross-Media Files</li>
                                <li>Exporting as a JPEG</li>
                                <li>Printing and Outputting a Document</li>
                                <li>Printing Presets</li>
                                <li>Printing a Document</li>
                                <li>Setting General and Setup Print Options</li>
                                <li>Printing an exported document</li>
                                <li>Setting Marks and Bleed Options</li>
                                <li>Setting Graphics Options</li>
                                <li>Previewing Color Separation</li>
                                <li>Setting Output options</li>
                                <li>Setting trapping options</li>
                                <li> Printing an exported document</li>
                                <li>Setting Advanced Options</li>
                                <li>Setting color management options</li>
                                <li>Creating a print Summary</li>
                                <li>Printing spreads in a booklet</li>
                                <li>Using Live Preflight</li>
                                <li>Inserting File Information</li>
                                <li>Setting Preferences</li>
                                <li>Setting General Preferences</li>
                                <li>Setting Interface Preferences</li>
                                <li>Setting Type Preferences</li>
                                <li>Setting Advanced Type Preferences</li>
                                <li>Setting Composition Preferences</li>
                                <li>Setting Units and increments Preferences</li>
                                <li>Dictionary Preferences</li>
                                <li>Spelling Preferences</li>
                                <li>Note Preferences</li>
                                <li>Black Preferences</li>
                                <li>Story Editor Display Preferences</li>
                                <li>File Handling Preferences</li>
                                <li>Setting preferences to use the application effectively.</li>
                                <li>Clipboard Handling Preferences</li>
                                <li>Shortcut Keys</li>
                                <li> Customizing Menus</li>
                                <li>Customizing Plug-ins</li>
                                <li>Customizing the Control Panel</li>
                                <li>Case Study- Magazine Cover Page</li>
                                <li>Creating magazine cover page in Adobe InDesign</li>
                                <li>Finishing up designing Magazine Cover Page</li>
                                <li>Getting to know about Adobe InDesign CC</li>
                                <li>Updates in Graphic Designing</li>
                                <li>Required skills to design graphics.</li>
                                <li>Tools for designing.</li>
                                <li>Exploring new features in InDesign</li>
                                <li>Designing graphics rapidly</li>
                                <li> Creating quirky designs</li>
                                <li>Enhancing the document</li>
                                <li> The SVG image support</li>
                                <li> Career opportunities for a bright future</li>
                                <li> Recruitment and various job profiles</li>
                                <li> Being careful and aware</li>
                                <li>Requirements to begin a career.</li>
                                <li>Combine Case Study Adobe Illustrator – InDesign</li>
                                <li> Case Study-Entry Pass Design</li>
                                <li> Objective</li>
                                <li>Designing an Entry Pass in Adobe Illustrator</li>
                                <li> Continuing Entry Pass design in Adobe Illustrator</li>
                                <li> Completing Entry Pass design in Adobe InDesign</li>
                                <li>Summary</li>
                                <li>Outcome</li>
                                <li>Case Study-Creating a book.</li>
                                <li>Objective</li>
                                <li>Designing a book in Adobe InDesign</li>
                                <li>Editing in Photoshop, finalizing in Adobe InDesign</li>
                                <li>Summary</li>
                                <li>Working smartly in Adobe InDesign</li>
                                <li>Combine Case Study Adobe Photoshop – InDesign</li>
                                <li>Case Study- Bill Book</li>
                                <li>Objective</li>
                                <li>Setting up a document and designing a Bill Book</li>
                                <li>Creating and exporting a Bill Book</li>
                                <li>Summary</li>
                                <li>Working smartly in Adobe InDesign</li>
                                <li>Using the shortcut keys for smart work</li>
                                <li>Shortcuts and Conclusion</li>
                                <li>Grabbing and merging data in Adobe InDesign</li>
                                <li>Understanding the objective behind merging data</li>
                                <li>Exploring benefits of data merging in InDesign</li>
                                <li>Listing requirements for merging data in InDesign</li>
                                <li>Merging data in InDesign using data source file</li>
                                <li>Understanding more about Data Merging</li>
                                <li>Using three tabs in merged document creation</li>
                                <li>Merging data using other source files</li>
                                <li>Merging data with MS Excel document</li>
                                <li>Merging data to enter numbers on tickets.</li>
                                <li>Merging MS Word and PDF documents in InDesign</li>
                                <li>Comparing Print and Data Merge in InDesign</li>
                                <li>Understanding what asset handling is</li>
                                <li>Learning the meaning and objectives</li>
                                <li>Exploring InDesign's asset handling capabilities</li>
                                <li>Exploring tools for managing assets in InDesign</li>
                                <li>Choosing the templates smartly</li>
                                <li>What are templates?</li>
                                <li>Creating visuals using templates in InDesign</li>
                                <li>Understanding the benefits of using templates</li>
                                <li>Finding useful sites for downloading templates</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="14">Envato</AccordionHeader>
                        <AccordionBody accordionId="14">
                            <ul>
                                <li>Envato</li>
                                <li>Learning what Envato is</li>
                                <li>Understanding the use of Envato</li>
                                <li>Getting the overview of user interface</li>
                                <li>Learning the smart tips for working</li>
                                <li>Outcome</li>
                                <li>Recalling key factors of ready-to-use templates</li>
                                <li>Discovering the major factors about templates</li>
                                <li>Exploring when to and how to use templates.</li>
                                <li>Efficient Designing within Deadlines</li>
                                <li>Identifying templates for various mediums</li>
                                <li>Identifying software using templates for work</li>
                                <li>Understanding how templates can ease and speed up your work.</li>
                                <li>Outcome</li>
                                <li>Learning Presenter Media and template use</li>
                                <li>What is PresenterMedia and its use?</li>
                                <li>Alternatives to PresenterMedia?</li>
                                <li>Use of Templates in PresenterMedia</li>
                                <li>Use of Templates in other websites</li>
                                <li>Interface Overview of PresenterMedia</li>
                                <li>Smarter tips for PresenterMedia, other sites</li>
                                <li> Outcome</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="15">Canva</AccordionHeader>
                        <AccordionBody accordionId="15">
                            <ul>
                                <li>What is Canva and what are its uses?</li>
                                <li> What are free Templates in Canva?</li>
                                <li> Essential Elements in Canva</li>
                                <li> Interface Overview of Canva</li>
                                <li>Smart tips to work in with Canva</li>
                                <li>Combine Case Study Adobe Illustrator – Scribus</li>
                                <li>Case Study-Product Manual</li>
                                <li>Objective</li>
                                <li>Product Manual: Understanding and Designing</li>
                                <li>Customizing and finalizing the Product Manual</li>
                                <li>Summary</li>
                                <li>Outcome</li>
                                <li>Case Study- Story Board</li>
                                <li>Objective</li>
                                <li>Beginning to design a storyboard.</li>
                                <li>Designing screens in storyboard with page setups</li>
                                <li>Summary</li>
                                <li>Outcome</li>
                                <li>Copyright</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>



            </div >
            <hr />
            <h4>Adobe Photoshop</h4>
            <p><b>Skills:</b> The Working Place, Customizing, Image and Color Modifications, Tools, Using the Brush and Paint, Working with Selections, Scaling, Knowing the Layers, Filter Gallery, Playing with Palettes</p>
            <p><b>Outputs:</b>Image color corrections, Photo Collage, Photo Manipulations, Image enhancement with filters

            </p>
            <hr />

            <div style={{ overflowX: 'auto' }}>
        <h5>Evaluation Pattern</h5>
        <Table bordered striped >
          <thead>
            <tr>
              <th>Section No.</th>
              <th>Section Name</th>
              <th>Total Marks</th>
              <th>Minimum Passing Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Learning Progression</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Internal Assessment</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Final Online Examination</td>
              <td>50</td>
              <td>20</td>
            </tr>
            <tr>
              <th colSpan="2" style={{ textAlign: "right" }}> Total</th>
              <th>100</th>
              <th>40</th>
            </tr>
            
          </tbody>
        </Table>
      </div>
      <hr />

      <div>
        <h5>Certificate of Completion</h5>
        <p>
          The certificate will be provided to the learner who will satisfy the below criteria:
        </p>
        
          <li>
            Learners who have successfully completed above mentioned 3 Sections i.e. Section 1, Section 2, and Section 3.
          </li>
          
        
      </div>
      <hr />
      <div>
        <h5>Fee Structure</h5>
        <p>Fee applicable from 2024 Batch onwards as mentioned below:</p>
        <Table bordered>
          <thead>
            <tr>
              <th>Mode</th>
              <th>Total Fee (Rupees)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Single Installment</td>
              <td>4500/-</td>
            </tr>
          </tbody>
        </Table>
        <p>Total fee is including of Course fees, Examination fees, and Certification fees.</p>
      </div>
     

      <li>
        <span style={{ color: 'red' }}>
         Additionally, the One Time Registration Fee is Rs. 100/-. </span>
      </li>
      


    </div >
    </>
    );
}
export default CertificateInformation12;